// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"9a8f99c0","276":"b339888e"}[chunkId] + ".chunk.js";
};